import { getDomain } from './url'

const getDomainAttribute = () => {
  const domain = getDomain() || ''
  return domain.includes('.') ? `;domain=.${domain}` : ''
}

export const setCookieOnDomain = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie =
    cname + '=' + cvalue + ';' + expires + `;path=/${getDomainAttribute()}`
}

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;'
}

export const getCookie = cname => {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const removeCookie = cname => {
  document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}

export const removeCookieOnDomain = cname => {
  document.cookie =
    cname +
    '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/' +
    getDomainAttribute()
}

export default {
  getCookie,
  setCookie,
  setCookieOnDomain,
  removeCookie,
  removeCookieOnDomain
}
